// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w6MV","question":"styles_question__29IB9","description":"styles_description__1O8o8"};